module.exports = __webpack_public_path__ + "assets/img/jiachib_2013_3.6643c1e6.jpg";